jQuery(function($) {
    $(document).ready(function() {
        /** Select2.js init */
        if($('body').hasClass('woocommerce')){
            $(".woocommerceArchive__options-select").select2({
                minimumResultsForSearch: Infinity,
                theme:'default'
            });
            $(document).on("woof_ajax_done", function(e) {
                $(".woocommerceArchive__options-select").select2({
                    minimumResultsForSearch: Infinity,
                    theme:'default'
                });
            });
            $(".woocommerceSingle__variations select").select2({
                minimumResultsForSearch: Infinity,
                width:'165px',
                theme:'classic'
            });
        }
        if($('body').hasClass('page-template-page-contact')){
            $(".wpcf7-select").select2({
                minimumResultsForSearch: Infinity,
                width:'100%',
                theme:'default'
            });
        }
    });
});